var _excluded = ["children", "className", "rowHeight", "tabByRow", "toggleSort"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

var TableRow = function TableRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rowHeight = _ref.rowHeight,
      tabByRow = _ref.tabByRow,
      toggleSort = _ref.toggleSort,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames('rt-tr', "table__row--".concat(rowHeight), className),
    role: "row"
  }, tabByRow ? {
    tabIndex: 0
  } : {
    tabIndex: -1
  }, rest), children);
};

TableRow.propTypes = {
  children: PropTypes.array,
  className: PropTypes.string,
  rowHeight: PropTypes.string,
  tabByRow: PropTypes.bool,
  toggleSort: PropTypes.func
};
TableRow.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableRow",
  "props": {
    "children": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "rowHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tabByRow": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "toggleSort": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default TableRow;